import { useApiMutationAdminConfirmOfflinePayment } from '@hooks-api/fortune-fastpass/use-api-confirm-offline-payment'
import { Button } from '@pets-ui/Button/Button'
import { type SnackbarVariantsProps } from '@pets-ui/Snackbar/SnackbarVariants'
import { useSnackbar } from '@pets-ui/Snackbar/useSnackbar'
import * as stylex from '@stylexjs/stylex'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom-v5'
import { useAdminOrders } from '../../hooks/use-admin-orders'
import { useCampaign } from '../../hooks/use-campaign'
import { setIsNeedCombine } from '../../store/reducer/admin-reducer'
import { type ErrorResponse } from '../../types/error-response'

const baseStyle = stylex.create({
  confirmButton: {
    borderRadius: 100,
    width: '100%',
  },
})

export const AdminButtonCounterCheckout = () => {
  const dispatch = useDispatch()
  const { openSnackbar } = useSnackbar<SnackbarVariantsProps>()
  const { t } = useTranslation()
  const history = useHistory()
  const { campaignCodeFromUrl } = useCampaign()
  const { destructuredData: orders } = useAdminOrders()
  const { trigger: confirmOfflinePayment, isMutating } = useApiMutationAdminConfirmOfflinePayment()

  if (!orders) return null

  const redirectToOrderCheck = async () => {
    dispatch(setIsNeedCombine(false))
    try {
      await confirmOfflinePayment({
        code: campaignCodeFromUrl,
        payment_transaction_id: orders.id,
      })

      /** NOTE: 會需要 admin check 的訂單，是 offline 付款的訂單，且有贈品 */
      const shouldCheckGiveaway = !orders.is_giveaway_dispatch && orders.has_offline_giveaway

      if (shouldCheckGiveaway) {
        history.push(`/admin/${campaignCodeFromUrl}/admin-order-check/${orders.id}`)
      }
      else {
        history.push(`/admin/${campaignCodeFromUrl}/admin-checked`)
      }
    }
    catch (e) {
      const axiosError = e as ErrorResponse
      const errorMessage = axiosError?.response?.data?.message || '此筆訂單尚未付款'
      openSnackbar({
        message: errorMessage,
        severity: 'error',
      })
    }
  }
  return (
    <Button
      rootStyle={baseStyle.confirmButton}
      color="red"
      onClick={redirectToOrderCheck}
      loading={isMutating}
    >
      {t('order.confirmOrder')}
    </Button>
  )
}
